module.exports = __webpack_public_path__ + "img/daichao1.ea04c4f5.png";